import { createApiClient, responseData } from '#lib/api/client.js';
import type { operations } from '#lib/api/generated/schema.js';

export type TalksGalleryParams =
	operations['getTalksGalleryPage']['parameters']['query'];

// Shared between the universal load (cache seeding, prefetch) and the page
// component's infinite query — the two must hash identically for the seeded
// first page to be found.
export const talksGalleryQueryKey = (params: TalksGalleryParams) => [
	'talks-gallery-page',
	params,
];

export const getTalksGalleryPage = async (
	fetchFn: typeof globalThis.fetch | undefined,
	query: TalksGalleryParams
) =>
	responseData(
		await createApiClient(fetchFn).GET('/website-api/pages/talks-gallery', {
			params: { query },
		})
	);
